import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { pure } from 'recompose'
import AutoRenewalHeader from './AutoRenewalHeader'
import StripeAutoRenewalInfo from './StripeAutoRenewalInfo'
import { MembershipType, StripeSetupIntentType } from 'types'
import { useToggle } from 'utils'

const propTypes = {
  clearStripeSetupIntent: PropTypes.func.isRequired,
  fetchStripeSetupIntent: PropTypes.func.isRequired,
  flashErrorMessage: PropTypes.func.isRequired,
  handleCancelAutoRenewal: PropTypes.func.isRequired,
  lastFour: PropTypes.string,
  membership: MembershipType.isRequired,
  onSuccess: PropTypes.func.isRequired,
  stripeCustomerId: PropTypes.string,
  stripeSetupIntent: StripeSetupIntentType,
  update: PropTypes.func.isRequired,
}

function AutoRenewal({
  clearStripeSetupIntent,
  fetchStripeSetupIntent,
  flashErrorMessage,
  handleCancelAutoRenewal,
  lastFour = null,
  membership,
  onSuccess,
  stripeCustomerId = null,
  stripeSetupIntent = null,
  update,
}) {
  const [editView, toggleEditView] = useToggle()
  const {
    auto_renew__c,
    membership_expiration_date__c,
    sfid: membershipId,
  } = membership

  return (
    <div className="card">
      <AutoRenewalHeader
        autorenews={auto_renew__c}
        handleCancelAutoRenewal={handleCancelAutoRenewal}
        membershipExpirationDate={membership_expiration_date__c}
        membershipId={membershipId}
      />
      {auto_renew__c === true && (
        <div className="card-inner">
          <StripeAutoRenewalInfo
            clearStripeSetupIntent={clearStripeSetupIntent}
            editView={editView}
            fetchStripeSetupIntent={fetchStripeSetupIntent}
            flashErrorMessage={flashErrorMessage}
            lastFour={lastFour}
            membership={membership}
            onSuccess={onSuccess}
            stripeCustomerId={stripeCustomerId}
            stripeSetupIntent={stripeSetupIntent}
            toggleEditView={toggleEditView}
            update={update}
          />
        </div>
      )}
    </div>
  )
}

AutoRenewal.propTypes = exact(propTypes)

export default pure(AutoRenewal)
